import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import type { SectionWithDownloadProps } from './types';
import { SectionHeader, SectionTitle, PrimaryButton } from './styles';

const SectionWithDownload: React.FC<SectionWithDownloadProps> = ({
  title,
  onDownload,
  children,
}) => (
  <section>
    <SectionHeader>
      <SectionTitle level={5}>{title}</SectionTitle>
      {onDownload && (
        <PrimaryButton
          type="primary"
          icon={<FontAwesomeIcon icon={faCloudArrowDown} />}
          onClick={onDownload}
          aria-label={`Download ${title}`}
        >
          Download
        </PrimaryButton>
      )}
    </SectionHeader>
    {children}
  </section>
);

export default React.memo(SectionWithDownload);
